import { useMemo } from 'react';
import { pathOr } from 'ramda';
import { FormHeader, PrevQuestionButton, ProgressBar, QuestionLayout, WidgetLayout, withQuestionSwitchAnim } from '../../components';
/**
 * Хук собирает в кучку кастомизирующие вьюшки, переданные в пропсе 'components'
 * То, что не было передано, берется из дефолтных компонентов внутри виджета
 * */

export function useCustomComponentsContext(props) {
  var stepsMapper = props.stepsMapper,
      question = props.question,
      enableSwitchAnim = props.enableSwitchAnim;
  var FormHeaderComponent = pathOr(FormHeader, ['components', 'FormHeaderComponent'], props);
  var ReturnButtonComponent = pathOr(PrevQuestionButton, ['components', 'ReturnButtonComponent'], props);
  var ProgressBarComponent = pathOr(ProgressBar, ['components', 'ProgressBarComponent'], props);
  var WidgetLayoutComponent = pathOr(WidgetLayout, ['components', 'WidgetLayoutComponent'], props);
  /**
   * Здесь - магия кастомного маппера шагов. Если есть маппер, то в 1м приоритете будет полученный из него компонент
   * Дополнительно, если включена анимация, то выполнится обертка хоком
   * */

  var _QuestionLayoutComponent = stepsMapper && stepsMapper(question) || pathOr(QuestionLayout, ['components', 'QuestionLayoutComponent'], props);

  var QuestionLayoutComponent = useMemo(function () {
    return enableSwitchAnim ? withQuestionSwitchAnim(_QuestionLayoutComponent) : _QuestionLayoutComponent;
  }, [_QuestionLayoutComponent, enableSwitchAnim]);
  return {
    ReturnButtonComponent: ReturnButtonComponent,
    FormHeaderComponent: FormHeaderComponent,
    ProgressBarComponent: ProgressBarComponent,
    QuestionLayoutComponent: QuestionLayoutComponent,
    WidgetLayoutComponent: WidgetLayoutComponent
  };
}